/**
 * CartIcon Component
 *
 * Cart icon with badge showing item count.
 * Links to /cart page.
 */

import Link from 'next/link'
import React from 'react'

import { Icon } from '@/components/Icon/Icon'
import { IconButton } from '@/components/IconButton/IconButton'
import { useCart } from '@/shared/cart/CartContext'
import { pxToRem } from '@/shared/styles/themes'
import { faCartShopping } from '@fortawesome/pro-light-svg-icons/faCartShopping'
import { Badge, styled } from '@mui/material'

export const CartIcon: React.FC = () => {
  const { itemCount } = useCart()

  return (
    <Link href="/cart" passHref legacyBehavior>
      <StyledCartButton size={'large'} aria-label={`Shopping cart with ${itemCount} items`}>
        <Badge
          badgeContent={itemCount}
          invisible={itemCount === 0}
          color="secondary"
          sx={{ fontWeight: 400 }}
        >
          <StyledIcon icon={faCartShopping} />
        </Badge>
      </StyledCartButton>
    </Link>
  )
}

const StyledCartButton = styled(IconButton)`
  color: #F5F2EE;

  &:hover {
    color: ${props => props.theme.palette.secondary.main};
  }
`

const StyledIcon = styled(Icon)`
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};

  ${props => props.theme.breakpoints.up('md')} {
    width: ${pxToRem(22)};
    height: ${pxToRem(22)};
  }
`

export default CartIcon
